import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API } from "../../api";

function PlacedOrder(props) {
  const [order, setOrder] = useState([]);

  useEffect(() => {
    if (props.token) {
      axios(`${API}orders/`, {
        headers: { Authorization: `Bearer ${props.token}` },
      })
        .then((res) => {
          const data = res.data.map((item) => {
            const result = props.products.find(
              (pitem) => Number(pitem.id) === Number(item.product)
            );
            return { ...item, title: result.title, image: result.image };
          });

          setOrder(data);
        })
        .catch((err) => console.log(err.response.data));
    }
  }, [props.products, props.token]);

  return (
    <div className="container">
      <p className="fw-bold h5">Placed Orders</p>
      <div>
        {order.length === 0 ? (
          <div>You Have No Order Placed</div>
        ) : (
          <div>
            {order.map((item, i) => {
              return (
                <div key={item.id} className="row align-items-center mb-3">
                  <div className="col-3">
                    <img
                      className="img-fluid img-thumbnail my_img"
                      src={item.image}
                      alt="..."
                    />
                  </div>
                  <div className="col-9">
                    <p className="m-0">
                      <span className="fw-bold">Name : </span> {item.title}
                    </p>
                    <p className="m-0">
                      <span className="fw-bold">Quantity : </span>
                      {item.quantity}
                    </p>
                    <p className="m-0">
                      <span className="fw-bold">Price : </span> {item.amount}
                    </p>
                    <p>
                      <span className="fw-bold">Status : </span> {item.status}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.userDetails.token,
    products: state.products,
  };
};
export default connect(mapStateToProps)(PlacedOrder);
